import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import * as api from "api/api";
import { EmailRoutingRuleResource, UpsertEmailRoutingRuleResource } from "api/resource/email-routing-rule";
import { arrayToById } from "redux/normalize";
import { loginReset } from "./authentication";

export interface EmailRoutingRulesState {
	loading?: boolean;
	error?: string | null;
	byId: {
		[emailMasterId: number]: EmailRoutingRuleResource;
	};
}

const initialState: EmailRoutingRulesState = {
	byId: {},
};

const fetchEmailRoutingRules = createAsyncThunk(
	"emailRoutingRules/fetch",
	async (payload, thunkAPI) => {
		thunkAPI.dispatch(emailRoutingRulesLoading());
		const result = api.getEmailRoutingRules();
		result
			.then((rules) => thunkAPI.dispatch(emailRoutingRulesReset(rules)))
			.catch((error) => thunkAPI.dispatch(emailRoutingRulesFailed(error)));
		return result;
	}
);

const saveEmailRoutingRules = createAsyncThunk(
	"emailRoutingRules/save",
	async (payload: UpsertEmailRoutingRuleResource[], thunkAPI) => {
		thunkAPI.dispatch(emailRoutingRulesLoading());
		const result = api.bulkUpsertEmailRoutingRules(payload);
		result
			.then((rules) => thunkAPI.dispatch(emailRoutingRulesLoaded(rules)))
			.catch((error) => thunkAPI.dispatch(emailRoutingRulesFailed(error)));
		return result;
	}
);

export const emailRoutingRulesSlice = createSlice({
	name: "emailRoutingRules",
	initialState,
	reducers: {
		emailRoutingRulesLoading: (state) => {
			state.loading = true;
		},
		emailRoutingRulesLoaded: (state, action: PayloadAction<EmailRoutingRuleResource[]>) => {
			state.loading = false;
			state.error = null;
			state.byId = { ...state.byId, ...arrayToById(action.payload, "emailMasterId") };
		},
		emailRoutingRulesReset: (state, action: PayloadAction<EmailRoutingRuleResource[]>) => {
			state.loading = false;
			state.error = null;
			state.byId = arrayToById(action.payload, "emailMasterId");
		},
		emailRoutingRulesFailed: (state, action: PayloadAction<any>) => {
			state.loading = false;
			state.error = action.payload.message;
		},
	},
	extraReducers(builder) {
		builder.addCase(loginReset, (state) => {
			return {
				...initialState,
				error: state.error,
			};
		});
	},
});

export const {
	emailRoutingRulesLoading,
	emailRoutingRulesLoaded,
	emailRoutingRulesReset,
	emailRoutingRulesFailed,
} = emailRoutingRulesSlice.actions;

export { fetchEmailRoutingRules, saveEmailRoutingRules };
